import { render } from "./Venta.vue?vue&type=template&id=4c7b89f6&scoped=true"
import script from "./Venta.vue?vue&type=script&lang=js"
export * from "./Venta.vue?vue&type=script&lang=js"

import "./Venta.vue?vue&type=style&index=0&id=4c7b89f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c7b89f6"]])

export default __exports__